
        import type { TemplateResult, TemplateRootPropsForTag } from 'Components/types';
type relatedItemsRTRootProps = TemplateRootPropsForTag<'div'>;
import { createElement as _createElement } from 'preact';
import { map as _map } from 'Utils/array';
import _translate from 'Utils/translate';
export default function relatedItemsRT(): TemplateResult<relatedItemsRTRootProps> {
    function repeatItems1(items, itemsIndex) {
        return [items(function () {
                function mergeProps(inline, external) {
                    var res = Object.assign({}, inline, external);
                    if (inline.hasOwnProperty('style')) {
                        res.style = _.defaults(res.style, inline.style);
                    }
                    if (inline.hasOwnProperty('className') && external.hasOwnProperty('className')) {
                        res.className = external.className + ' ' + inline.className;
                    }
                    return res;
                }
                return _createElement('li', { 'className': 'entry content-bg loop-entry product' }, _createElement('a', {
                    'href': this.url,
                    'className': 'woocommerce-loop-image-link woocommerce-LoopProduct-link woocommerce-loop-product__link'
                }, this.on_sale ? _createElement('span', {
                    'className': 'onsale',
                    'key': '173'
                }, 'Sale') : null, _createElement('img', {
                    'data-perfmatters-preload': true,
                    'width': '300',
                    'height': '300',
                    'src': this.imageOrDefault(this.image),
                    'className': 'attachment-woocommerce_thumbnail size-woocommerce_thumbnail',
                    'decoding': 'async',
                    'fetchpriority': 'high',
                    'onError': this.onImageError
                })), _createElement('div', { 'className': 'product-details content-bg entry-content-wrap' }, _createElement('h2', { 'className': 'woocommerce-loop-product__title' }, _createElement('a', mergeProps({
                    'href': this.url,
                    'className': 'woocommerce-LoopProduct-link-title woocommerce-loop-product__title_ink'
                }, { dangerouslySetInnerHTML: { __html: typeof this.name === 'undefined' ? '' : this.name } }))), this.review_average > 0 ? _createElement('div', {
                    'className': 'star-rating',
                    'role': 'img',
                    'aria-label': 'Rated ' + this.review_average + ' out of 5',
                    'key': '840'
                }, _createElement('span', { 'style': { width: this.review_average * 20 + '%' } }, '\n        Rated ', _createElement('strong', { 'className': 'rating' }, this.review_average), ' out of 5\n      ')) : null, _createElement('span', { 'className': 'price' }, this.on_sale ? [
                    _createElement('del', {
                        'aria-hidden': 'true',
                        'key': '11521'
                    }, _createElement('span', { 'className': 'woocommerce-Price-amount amount' }, _createElement('bdi', {}, this.formatPrice(this.regular_price)))),
                    _createElement('span', {
                        'className': 'screen-reader-text',
                        'key': '11523'
                    }, 'Original price was: ', this.formatPrice(this.regular_price), '.'),
                    _createElement('ins', {
                        'aria-hidden': 'true',
                        'key': '11525'
                    }, _createElement('span', { 'className': 'woocommerce-Price-amount amount' }, _createElement('bdi', {}, this.formatPrice(this.price)))),
                    _createElement('span', {
                        'className': 'screen-reader-text',
                        'key': '11527'
                    }, 'Current price is: ', this.formatPrice(this.price), '.')
                ] : null, !this.on_sale ? _createElement('span', {
                    'className': 'woocommerce-Price-amount amount',
                    'key': '1781'
                }, _createElement('bdi', {}, this.formatPrice(this.price))) : null), _createElement('div', { 'className': 'product-action-wrap' }, _createElement('a', {
                    'href': this.has_options ? this.url : `?add-to-cart=${ this.product_id }`,
                    'onClick': e => !this.has_options ? window.Convermax.addToCart(e) : null,
                    'data-quantity': '1',
                    'className': 'button product_type_simple add_to_cart_button ajax_add_to_cart',
                    'data-product_id': this.product_id,
                    'data-product_sku': this.sku ?? 'UniversalCredit',
                    'aria-label': 'Add to cart: ' + this.name,
                    'rel': 'nofollow'
                }, '\n        ', this.out_of_stock ? _translate(`product_out_of_stock`) : this.has_options ? _translate(`product_select_options`) : _translate(`product_add_to_cart`), '\n        ', _createElement('span', { 'className': 'kadence-svg-iconset svg-baseline' }, _createElement('svg', {
                    'aria-hidden': 'true',
                    'className': 'kadence-svg-icon kadence-arrow-right-alt-svg',
                    'fill': 'currentColor',
                    'version': '1.1',
                    'xmlns': 'http://www.w3.org/2000/svg',
                    'width': '27',
                    'height': '28',
                    'viewBox': '0 0 27 28'
                }, _createElement('title', {}, 'Continue'), _createElement('path', { 'd': 'M27 13.953c0 0.141-0.063 0.281-0.156 0.375l-6 5.531c-0.156 0.141-0.359 0.172-0.547 0.094-0.172-0.078-0.297-0.25-0.297-0.453v-3.5h-19.5c-0.281 0-0.5-0.219-0.5-0.5v-3c0-0.281 0.219-0.5 0.5-0.5h19.5v-3.5c0-0.203 0.109-0.375 0.297-0.453s0.391-0.047 0.547 0.078l6 5.469c0.094 0.094 0.156 0.219 0.156 0.359v0z' })), _createElement('svg', {
                    'className': 'kadence-svg-icon kadence-spinner-svg',
                    'fill': 'currentColor',
                    'version': '1.1',
                    'xmlns': 'http://www.w3.org/2000/svg',
                    'width': '16',
                    'height': '16',
                    'viewBox': '0 0 16 16'
                }, _createElement('title', {}, 'Loading'), _createElement('path', { 'd': 'M16 6h-6l2.243-2.243c-1.133-1.133-2.64-1.757-4.243-1.757s-3.109 0.624-4.243 1.757c-1.133 1.133-1.757 2.64-1.757 4.243s0.624 3.109 1.757 4.243c1.133 1.133 2.64 1.757 4.243 1.757s3.109-0.624 4.243-1.757c0.095-0.095 0.185-0.192 0.273-0.292l1.505 1.317c-1.466 1.674-3.62 2.732-6.020 2.732-4.418 0-8-3.582-8-8s3.582-8 8-8c2.209 0 4.209 0.896 5.656 2.344l2.343-2.344v6z' })), _createElement('svg', {
                    'className': 'kadence-svg-icon kadence-check-svg',
                    'fill': 'currentColor',
                    'version': '1.1',
                    'xmlns': 'http://www.w3.org/2000/svg',
                    'width': '16',
                    'height': '16',
                    'viewBox': '0 0 16 16'
                }, _createElement('title', {}, 'Done'), _createElement('path', { 'd': 'M14 2.5l-8.5 8.5-3.5-3.5-1.5 1.5 5 5 10-10z' })))))));
            }, { count: undefined })];
    }
    return _createElement('div', { 'className': 'cm_related-products' }, _createElement('div', { 'className': 'cm_related-products-title-container' }, _createElement('h2', { 'className': 'cm_related-products-title' }, _translate(`related_items_title`))), _createElement.apply(this, [
        'ul',
        { 'className': 'content-wrap grid-cols grid-lg-col-4 grid-sm-col-3 grid-ss-col-2 products woo-archive-action-visible cm_related-products-list cmRepeater_items' },
        _map(this.items, repeatItems1.bind(this))
    ]));
}
        export const componentNames = []